import React from "react";

import {
  StyledHomePageHaveQuestionsBlock,
  StyledHomePageStillHaveQuestionsWrapper,
  StyledStillHaveQuestionsContainer,
  StyledStillHaveQuestionsImage,
  StyledStillHaveQuestionsText
} from "./styledHomePageStillHaveQuestions";
import { StyledButton } from "../../styles/styledButton";

const HomePageStillHaveQuestions = () => {
  return (
    <StyledHomePageStillHaveQuestionsWrapper>
      <StyledHomePageHaveQuestionsBlock>
        <StyledStillHaveQuestionsContainer>
          <StyledStillHaveQuestionsImage />
          <StyledStillHaveQuestionsText>
            <h5>
              Still have questions?
            </h5>
            <p>
              If you still have any questions regarding cooperation with the Text me chat, then contact our support service and we will be happy to advise you.
            </p>
          </StyledStillHaveQuestionsText>
          <StyledButton
            as="a"
            href="#contact"
            color="white"
          >
            <span>
              Contact us
            </span>
          </StyledButton>
        </StyledStillHaveQuestionsContainer>
      </StyledHomePageHaveQuestionsBlock>
    </StyledHomePageStillHaveQuestionsWrapper>
  );
};

export default HomePageStillHaveQuestions;